/* KonpreShop · Guía de tallas
   - Carga UNA vez assets/ks-size-guides.json (en idle, con caché) y muestra el botón
     solo si el handle del producto está en "map".
   - Si algo falla, el botón se queda oculto y no se escribe nada en la consola.
   - La ventana es un <dialog> creado al abrir por primera vez. No toca el carrito,
     las variantes, Aplazo ni el stock. */
(function () {
  'use strict';

  var trigger = document.querySelector('[data-ks-sg-open]');
  if (!trigger || trigger.getAttribute('data-ks-sg-ready')) return;
  trigger.setAttribute('data-ks-sg-ready', '1');

  var jsonUrl = trigger.getAttribute('data-ks-sg-src') || '';
  var handle = trigger.getAttribute('data-ks-sg-handle') || '';
  var productTitle = trigger.getAttribute('data-ks-sg-title') || '';
  if (!jsonUrl || !handle || typeof window.fetch !== 'function') return;

  var guides = [];          // guías de ESTE producto, ya validadas
  var dlg = null;           // <dialog>
  var closeX = null;
  var bodyEl = null;
  var opener = null;
  var usePoly = false;      // sin showModal()
  var downOnBackdrop = false;

  var BASIS = { cuerpo: 'Medidas de tu cuerpo', prenda: 'Medidas de la prenda' };
  var ALLOWED = { P: 1, STRONG: 1, EM: 1, B: 1, I: 1, UL: 1, OL: 1, LI: 1, TABLE: 1, CAPTION: 1, THEAD: 1, TBODY: 1, TFOOT: 1, TR: 1, TH: 1, TD: 1, SMALL: 1, BR: 1 };
  var DROP = { SCRIPT: 1, STYLE: 1, IFRAME: 1, OBJECT: 1, EMBED: 1, SVG: 1, MATH: 1, LINK: 1, META: 1, TEMPLATE: 1, NOSCRIPT: 1, IMG: 1, VIDEO: 1, AUDIO: 1, FORM: 1, INPUT: 1, BUTTON: 1, TEXTAREA: 1, SELECT: 1 };
  var KEEP_ATTR = { scope: 1, colspan: 1, rowspan: 1 };

  /* ---------- utilidades ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function safe(fn) { try { return fn(); } catch (e) { return undefined; } }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').replace(',', '.').trim(); }
  function isHttp(u) { return typeof u === 'string' && /^https?:\/\//i.test(u); }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  /* Deja solo las etiquetas del contrato (p, strong, em, ul, li, table…) y quita atributos. */
  function clean(node) {
    Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
      if (ch.nodeType === 3) return;
      if (ch.nodeType !== 1) { node.removeChild(ch); return; }
      var tag = ch.tagName.toUpperCase();
      if (DROP[tag]) { node.removeChild(ch); return; }
      clean(ch);
      if (!ALLOWED[tag]) {
        while (ch.firstChild) node.insertBefore(ch.firstChild, ch);
        node.removeChild(ch);
        return;
      }
      Array.prototype.slice.call(ch.attributes).forEach(function (a) {
        if (!KEEP_ATTR[a.name]) ch.removeAttribute(a.name);
      });
    });
  }

  function buildContent(html) {
    var box = el('div', 'ks-sg__content');
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var frag = tpl.content;
    clean(frag);
    box.appendChild(frag);
    Array.prototype.slice.call(box.querySelectorAll('table')).forEach(function (t) {
      var wrap = el('div', 'ks-sg__scroll');
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });
    return box;
  }

  function sourceNode(g) {
    if (!g.source) return null;
    var p = el('p', 'ks-sg__src');
    p.appendChild(document.createTextNode('Fuente: '));
    if (isHttp(g.source_url)) {
      var a = el('a', '', g.source);
      a.href = g.source_url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      p.appendChild(a);
      p.appendChild(el('span', 'ks-sg__sr', ' (se abre en otra pestaña)'));
    } else {
      p.appendChild(document.createTextNode(g.source));
    }
    return p;
  }

  function basisNode(g) {
    var t = BASIS[g.basis];
    return t ? el('p', 'ks-sg__basis', t) : null;
  }

  /* ---------- construir la ventana (una sola vez) ---------- */
  function build() {
    if (dlg) return;
    var multi = guides.length > 1;

    dlg = document.createElement('dialog');
    dlg.className = 'ks-sg';
    dlg.id = 'ks-sg-dialog';
    dlg.setAttribute('aria-labelledby', 'ks-sg-title');

    var head = el('div', 'ks-sg__head');
    var txt = el('div', 'ks-sg__head-text');
    var h = el('h2', 'ks-sg__title', 'Guía de tallas');
    h.id = 'ks-sg-title';
    txt.appendChild(h);
    if (productTitle) txt.appendChild(el('p', 'ks-sg__product', productTitle));
    closeX = el('button', 'ks-sg__x');
    closeX.type = 'button';
    closeX.setAttribute('aria-label', 'Cerrar guía de tallas');
    closeX.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    head.appendChild(txt);
    head.appendChild(closeX);

    bodyEl = el('div', 'ks-sg__body');
    guides.forEach(function (g, i) {
      var inner = el('div', multi ? 'ks-sg__acc-body' : 'ks-sg__guide');
      if (!multi && g.title) inner.appendChild(el('h3', 'ks-sg__guide-title', g.title));
      var b = basisNode(g);
      if (b) inner.appendChild(b);
      inner.appendChild(buildContent(g.html));
      if (!multi) { bodyEl.appendChild(inner); return; }
      var d = el('details', 'ks-sg__acc');
      if (i === 0) d.open = true;
      var s = el('summary');
      s.appendChild(el('span', '', g.title || ('Guía ' + (i + 1))));
      d.appendChild(s);
      var src = sourceNode(g);
      if (src) inner.appendChild(src);
      d.appendChild(inner);
      bodyEl.appendChild(d);
    });

    var foot = el('div', 'ks-sg__foot');
    if (!multi) {
      var fs = sourceNode(guides[0]);
      if (fs) foot.appendChild(fs);
    }
    var closeBtn = el('button', 'ks-sg__close', 'Cerrar');
    closeBtn.type = 'button';
    foot.appendChild(closeBtn);

    dlg.appendChild(head);
    dlg.appendChild(bodyEl);
    dlg.appendChild(foot);
    document.body.appendChild(dlg);

    usePoly = typeof dlg.showModal !== 'function';
    if (usePoly) dlg.classList.add('ks-sg--poly');

    closeX.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    dlg.addEventListener('mousedown', function (e) { downOnBackdrop = (e.target === dlg); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && downOnBackdrop) close();
      downOnBackdrop = false;
    });
    dlg.addEventListener('close', onClosed);
    dlg.addEventListener('keydown', onKey);
  }

  /* ---------- talla seleccionada: resaltar su fila ---------- */
  function currentSize() {
    var scope = trigger.closest('.pdp-opt') || document;
    var b = scope.querySelector('.size-pick[aria-pressed="true"]');
    return b ? norm(b.getAttribute('data-value') || b.textContent) : '';
  }

  function highlight() {
    var marked = dlg.querySelectorAll('tr.ks-sg-current');
    Array.prototype.forEach.call(marked, function (r) { r.classList.remove('ks-sg-current'); r.removeAttribute('aria-current'); });
    var size = currentSize();
    if (!size) return null;
    var rows = Array.prototype.slice.call(dlg.querySelectorAll('tbody tr'));
    var first = null;
    function mark(want) {
      rows.forEach(function (tr) {
        var cell = tr.querySelector('th[scope="row"]') || tr.cells[0];
        if (cell && norm(cell.textContent) === want) {
          tr.classList.add('ks-sg-current');
          tr.setAttribute('aria-current', 'true');
          if (!first) first = tr;
        }
      });
    }
    mark(size);
    // Pantalones con "cintura/largo" (p. ej. 32/30): si no hay fila exacta, usa la cintura.
    if (!first && size.indexOf('/') > 0) mark(size.split('/')[0].trim());
    return first;
  }

  /* Tablas que sí desbordan: se pueden enfocar con teclado */
  function markScrollable() {
    if (!dlg) return;
    Array.prototype.forEach.call(dlg.querySelectorAll('.ks-sg__scroll'), function (w) {
      if (w.scrollWidth > w.clientWidth + 1) {
        var cap = w.querySelector('caption');
        w.setAttribute('tabindex', '0');
        w.setAttribute('role', 'region');
        w.setAttribute('aria-label', 'Tabla de medidas' + (cap && cap.textContent ? ': ' + cap.textContent.trim() : '') + ' (se desplaza hacia los lados)');
      } else {
        w.removeAttribute('tabindex');
        w.removeAttribute('role');
        w.removeAttribute('aria-label');
      }
    });
  }

  function revealRow(row) {
    if (!row || !bodyEl) return;
    var r = row.getBoundingClientRect();
    var b = bodyEl.getBoundingClientRect();
    if (r.top < b.top + 8 || r.bottom > b.bottom - 8) {
      bodyEl.scrollTop += (r.top - b.top) - (b.height - r.height) / 2;
    }
  }

  /* ---------- abrir / cerrar ---------- */
  function lock() { document.documentElement.classList.add('ks-sg-lock'); }
  function unlock() { document.documentElement.classList.remove('ks-sg-lock'); }

  function open() {
    safe(function () {
      build();
      if (!dlg || dlg.hasAttribute('open')) return;
      opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : trigger;
      bodyEl.scrollTop = 0;
      var row = highlight();
      if (row) { var det = row.closest('details'); if (det) det.open = true; }
      lock();
      if (usePoly) {
        dlg.setAttribute('open', '');
        dlg.setAttribute('role', 'dialog');
        dlg.setAttribute('aria-modal', 'true');
        document.addEventListener('mousedown', onOutside, true);
      } else {
        dlg.showModal();
      }
      window.addEventListener('resize', markScrollable);
      markScrollable();
      revealRow(row);
      closeX.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!dlg) return;
    if (usePoly) {
      if (dlg.hasAttribute('open')) { dlg.removeAttribute('open'); onClosed(); }
    } else if (dlg.open) {
      dlg.close();
    }
  }

  function onOutside(e) { if (dlg && !dlg.contains(e.target)) close(); }

  function onClosed() {
    window.removeEventListener('resize', markScrollable);
    document.removeEventListener('mousedown', onOutside, true);
    unlock();
    var back = opener && document.contains(opener) ? opener : trigger;
    opener = null;
    safe(function () { back.focus({ preventScroll: true }); });
  }

  function onKey(e) {
    if (!usePoly) return; // el <dialog> nativo ya maneja ESC y el foco
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(dlg.querySelectorAll('button, a[href], summary, [tabindex="0"]'), function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- cargar datos (una vez, en idle) ---------- */
  function ready(data) {
    var map = data && data.map;
    var all = data && data.guides;
    if (!map || !all || typeof map !== 'object' || typeof all !== 'object') return;
    var ids = null;
    var keys = [handle, safe(function () { return decodeURIComponent(handle); }), safe(function () { return encodeURIComponent(handle); })];
    for (var i = 0; i < keys.length && !ids; i++) {
      if (keys[i] && has(map, keys[i]) && Array.isArray(map[keys[i]])) ids = map[keys[i]];
    }
    if (!ids) return;
    guides = ids.map(function (id) { return has(all, id) ? all[id] : null; })
      .filter(function (g) { return g && typeof g === 'object' && typeof g.html === 'string' && g.html.replace(/\s/g, '') !== ''; });
    if (!guides.length) return;
    trigger.addEventListener('click', open);
    trigger.hidden = false;
  }

  function load() {
    safe(function () {
      window.fetch(jsonUrl, { cache: 'force-cache', credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
        .then(ready)
        .catch(function () { /* sin botón, sin ruido */ });
    });
  }

  if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(load, { timeout: 2500 });
  else window.setTimeout(load, 400);
})();
